document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.download-btn a').forEach(function (link) {
      link.setAttribute('download', '');
    });
});